<a class="mb-3" *ngIf="!isEquityAnalysis" href="#" (click)="openSaveOnMortgageArticleSheet(); $event.preventDefault()">
  Learn how to save on your mortgage
</a>
<div class="row mt-3">
  <div class="col-12">
    <div class="table-responsive">
      <table class="mtable">
        <tr>
          <td class="p-0 table-scroll">
            <table class="border1 tab-head">
              <tr>
                <th><div>&nbsp;</div></th>
              </tr>
              <tr>
                <td>Mortgage Date</td>
              </tr>
              <tr>
                <td>Principal</td>
              </tr>
              <tr>
                <td>Interest Rate</td>
              </tr>
              <tr>
                <td>Term</td>
              </tr>
              <tr>
                <td>Current Loan Balance (Est)</td>
              </tr>
              <tr>
                <td>Principal</td>
              </tr>
              <tr>
                <td>Interest</td>
              </tr>
              <tr>
                <td class="m-head">&nbsp;</td>
              </tr>
            </table>
          </td>
          <td class="p-0" *ngFor="let mortgage of mortgageArray; let i = index">
            <table class="w-100 data-tab border1">
              <tr>
                <th>
                  <div>
                    <b class="pr-2">Mortgage {{ i + 1 }}</b>
                    <button class="action" (click)="editMortgage(mortgage, i)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button class="action" (click)="deleteMortgage(mortgage.id, i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </th>
              </tr>
              <tr>
                <td>{{ mortgage['startDate'] | date }}</td>
              </tr>
              <tr>
                <td>{{ mortgage['principal'] | currency: 'USD':'symbol':'0.0-0' }}</td>
              </tr>
              <tr>
                <td>{{ mortgage['interest'] }}%</td>
              </tr>
              <tr>
                <td>{{ mortgage['term'] / 12 }}Years</td>
              </tr>
              <tr>
                <td>
                  {{ mortgage['principalBalance'] | currency: 'USD':'symbol':'0.0-0' }}
                </td>
              </tr>
              <tr>
                <td style="display: inline-block; padding-top: 10px">
                  <div class="principal-value" style="width: 260px; display: flex">
                    <span
                      [style.flex-basis.%]="
                        (
                          (mortgage['principalPaid'] / (mortgage['principalPaid'] + mortgage['principalBalance'])) *
                          100
                        ).toFixed(1)
                      "
                      class="paid"
                      >{{ mortgage['principalPaid'] | currency: 'USD':'symbol':'0.0-0' }}</span
                    ><span
                      [style.flex-basis.%]="
                        (
                          (mortgage['principalBalance'] / (mortgage['principalPaid'] + mortgage['principalBalance'])) *
                          100
                        ).toFixed(1)
                      "
                      class="balance"
                      >{{ mortgage['principalBalance'] | currency: 'USD':'symbol':'0.0-0' }}</span
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td style="display: inline-block; padding-top: 10px">
                  <div class="principal-value" style="width: 260px; display: flex">
                    <span
                      [style.flex-basis.%]="
                        (
                          (mortgage['interestPaid'] / (mortgage['interestPaid'] + mortgage['interestBalance'])) *
                          100
                        ).toFixed(1)
                      "
                      class="paid"
                      >{{ mortgage['interestPaid'] | currency: 'USD':'symbol':'0.0-0' }}</span
                    ><span
                      [style.flex-basis.%]="
                        (
                          (mortgage['interestBalance'] / (mortgage['interestPaid'] + mortgage['interestBalance'])) *
                          100
                        ).toFixed(1)
                      "
                      class="balance"
                      >{{ mortgage['interestBalance'] | currency: 'USD':'symbol':'0.0-0' }}</span
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mr-4"><span class="mpaid"></span>Paid</span>
                  <span><span class="mbalance"></span>Balance</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
